import { useState, useEffect } from 'react';
import { useDispatch } from 'react-redux';
import PropTypes from 'prop-types';

import { generateUUID } from '../../../utils/util';

import { requestCreateReaction, requestDeletePost } from '../../../api/market-buzz/market-buzz.actions';
import { addReactionToPost, deleteReactionFromPost } from '../../../slices/market-buzz/market-buzz.slice';

import Poll from '../../../components/common/poll/Poll';

const PollContainer = ({ postExternalReference, question, options, reactions, reactionCount }) => {
  const [poll, setPoll] = useState(undefined);

  const dispatch = useDispatch();

  useEffect(() => {
    const filteredReactions = reactions.filter(
      (reaction) => reaction.parentPostExternalReference === postExternalReference
    );

    const poll = {
      question,
      options: options.map((option) => {
        const votes = reactionCount.find((reaction) => reaction.text === option)?.count || 0;
        const voted = filteredReactions.some((reaction) => reaction.reaction === option);

        return { id: generateUUID(), value: option, votes, voted };
      }),
    };

    setPoll(poll);
  }, [question, options, postExternalReference, reactionCount, reactions]);

  const createReaction = (reactionType) => {
    const reaction = {
      reaction: reactionType,
      parentPostExternalReference: postExternalReference,
    };

    dispatch(
      requestCreateReaction({
        reaction,
        onSuccess: (data) => {
          dispatch(
            addReactionToPost({
              reactionExternalReference: data.externalReference,
              reaction,
              postExternalReference,
            })
          );
        },
      })
    );
  };

  const deleteReaction = (reactionType) => {
    const filteredReactions = reactions.filter(
      (reaction) => reaction.parentPostExternalReference === postExternalReference
    );

    const foundReaction = filteredReactions.find((reaction) => reaction.reaction === reactionType);

    dispatch(
      requestDeletePost({
        postExternalReference: foundReaction.externalReference,
        reaction: true,
        onSuccess: () => {
          dispatch(
            deleteReactionFromPost({
              reactionExternalReference: foundReaction.externalReference,
              reactionType,
              postExternalReference,
            })
          );
        },
      })
    );
  };

  return <Poll poll={poll} createReaction={createReaction} deleteReaction={deleteReaction} post />;
};

PollContainer.propTypes = {
  postExternalReference: PropTypes.string.isRequired,
  question: PropTypes.string.isRequired,
  options: PropTypes.arrayOf(PropTypes.string).isRequired,
  reactions: PropTypes.arrayOf(PropTypes.shape({})).isRequired,
  reactionCount: PropTypes.arrayOf(PropTypes.shape({})).isRequired,
};

export default PollContainer;
